import { FC, ReactNode } from 'react';
import { shownChartLabel } from '../chartValues';

type Props = {
  /** Заголовок группы; пустой — элементы идут перечнем без заголовка */
  title: string;
  children: ReactNode;
};

/** Озаглавленная группа элементов диаграммы: заголовок — подпись группы в показанном виде. */
export const ChartGroupSection: FC<Props> = ({ title, children }) => (
  <div className="flex flex-col gap-2">
    {title && <h4 className="text-sm font-medium text-muted-foreground">{shownChartLabel(title)}</h4>}
    {children}
  </div>
);
